
import React from 'react';
import _ from 'lodash';
import { Card, CardContent, CardHeader, Typography } from '@mui/material';
import { FormFieldPanel } from './FormFieldPanel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { CircularProgressContainer } from '../others/CircularProgressContainer';

export const SectionPanel = props => {
  const { section, formik, updateOptionsCallback, yupRequiredFieldsCallback, bigFamilyCardCallback, updateDiscountsCallback, historicDataByPeselCallback, checkActivitiesCallback, setDateToCallback, hideFieldCallback, handleDiscountActions, handleParishChange, handleGroupChange, handleEventChange, handlePeriodChange, handleSourceOfOfferChange, formVersion } = props;
  const [loading, setLoading] = React.useState(false);

  const setLoadingCallback = bool => setLoading(bool);

  const getFieldCallback = fieldName => _.find(section.fields, obj => {
    if (obj.name === fieldName) {

      return obj;
    }
  });

  const prepareYupRequiredFieldsCallback = (params, index, newVal) => {
    yupRequiredFieldsCallback(params, section.id, index, newVal);
  };

  const prepareBigFamilyCardCallback = (params, index) => {
    bigFamilyCardCallback(params, section.id, index);
  };

  const prepareUpdateDiscountsCallback = (discount, discountArr, latestId) => updateDiscountsCallback(discount, section.id, discountArr, latestId);

  const prepareHideFieldCallback = (fieldName, reverse = false) => {
    hideFieldCallback(fieldName, section.id, reverse);
  };

  const prepareHandleDiscountActions = (id, sections) => {
    handleDiscountActions(id, section.id, sections);
  };

  const prepareHandleParishChange = id => {
    handleParishChange(id, section.id);
  };

  const prepareHandleGroupChange = (id, sections) => {
    handleGroupChange(id, section.id, sections);
  };

  const prepareHandleEventChange = val => {
    handleEventChange(val, section.id);
  };

  const prepareHandlePeriodChange = (v, sections) => {
    handlePeriodChange(v, section.id, sections);
  };

  const prepareHandleSourceOfOfferChange = id => {
    handleSourceOfOfferChange(id, section.id);
  };

  return (
    <Card
      style={{ marginRight: 7, marginLeft: 7, marginBottom: 10, opacity: loading ? 0.5 : 1 }}
      elevation={4}>
      { section.title || section.fa_icon
        ? <CardHeader
          title={ section.icon_side === 'right'
            ? <Typography variant="h5">
              <b style={{ marginRight: '10px' }}>{section.title}</b>
            &nbsp;
              {!_.isEmpty(section.fa_icon)
                ? <FontAwesomeIcon
                  icon={['fas', section.fa_icon]}
                  color="white" />
                : null}
            </Typography>
            : <Typography variant="h5">
              {!_.isEmpty(section.fa_icon)
                ? <FontAwesomeIcon
                  icon={['fas', section.fa_icon]}
                  color="white" />
                : null
              }
            &nbsp;
              <b style={{ marginLeft: '10px' }}><span dangerouslySetInnerHTML={{ __html: section.title }}></span></b>
            </Typography>
          }
          style={{ backgroundColor: '#9B231F', paddingBottom: 20, color: 'white' }}
        />
        : null}
      <CardContent>
        {loading
          ? <CircularProgressContainer size={50} thickness={2.5} />
          : null}
        {_.map(section.fields, (obj, idx) => (
          <FormFieldPanel
            field={obj}
            key={idx}
            formik={formik}
            updateOptionsCallback={updateOptionsCallback}
            getFieldCallback={getFieldCallback}
            setLoadingCallback={setLoadingCallback}
            yupRequiredFieldsCallback={prepareYupRequiredFieldsCallback}
            bigFamilyCardCallback={prepareBigFamilyCardCallback}
            updateDiscountsCallback={prepareUpdateDiscountsCallback}
            historicDataByPeselCallback={historicDataByPeselCallback}
            checkActivitiesCallback={checkActivitiesCallback}
            setDateToCallback={setDateToCallback}
            hideFieldCallback={prepareHideFieldCallback}
            handleDiscountActions={prepareHandleDiscountActions}
            handleParishChange={prepareHandleParishChange}
            handleGroupChange={prepareHandleGroupChange}
            handleEventChange={prepareHandleEventChange}
            handlePeriodChange={prepareHandlePeriodChange}
            handleSourceOfOfferChange={prepareHandleSourceOfOfferChange}
            formVersion={formVersion}
          />
        ))}
      </CardContent>
    </Card>
  );
};
